export const COMPLIANCE_TRACKING = [
  {
    label: 'label.DESKTOP',
    value: 'sigcompliancedesktop'
  },
  {
    label: 'label.MOBILE',
    value: 'sigcompliancemobile'
  },
  {
    label: 'label.FRONTAPP',
    value: 'sigcompliancefrontapp'
  },
  {
    label: 'label.MARKETO',
    value: 'sigcompliancemarketo'
  },
  {
    label: 'label.OUTREACH',
    value: 'sigcomplianceoutreach'
  },
  {
    label: 'label.SALESFORCE',
    value: 'sigcompliancesalesforce'
  },
  {
    label: 'label.SALESLOFT',
    value: 'sigcompliancesalesloft'
  },
  {
    label: 'label.HUBSPOT',
    value: 'sigcompliancehubspot'
  }
];
